var _style, _g, _path, _g2, _path2, _path3, _g3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _g4, _g5, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g6, _g7, _path17, _g8, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockersale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 665.2 569.3",
    style: {
      enableBackground: "new 0 0 665.2 569.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9BCC8F;}\n\t.st1{opacity:0.25;fill:#B32E5D;enable-background:new    ;}\n\t.st2{fill:#47393D;}\n\t.st3{fill:#EAEAEA;}\n\t.st4{fill:#B32E5D;}\n\t.st5{fill:#707070;}\n\t.st6{fill:#4F4F4F;}\n\t.st7{fill:#B7A9D3;}\n\t.st8{fill:#163560;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:#744DA5;}\n\t.st11{fill:#FFB27D;}\n\t.st12{fill:#233862;}\n\t.st13{fill:#E8945B;}\n\t.st14{fill:#1C468A;}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#1C468A;}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:#233862;}\n\t.st17{fill:#8A69B3;}\n\t.st18{fill:#FFBD9B;}\n\t.st19{fill:#41B8E1;}\n\t.st20{fill:#4A2C76;}\n\t.st21{fill:#DBFAFC;}\n\t.st22{fill:#C8D1CE;}\n\t.st23{fill:#6BC8E8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000068636883924264676940000013386963008549757597_"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.4,611.5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.5,495c-40.7-17.6-97.9-116.7-16.6-209.6c50.8-58.1-29-181.2,121-257.9c98-50.1,312.6-13.9,428.7,125.6 c78.9,94.8,80.7,234.3,18.6,340.7L63.5,495z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M641.1,437.5c-0.5-0.1-6.6-0.1-7.1-0.1c-7.4,0.1-24.1,1.3-32.2,10.8c-10.4,12.2-19.5,10.8-36.7,4.3 c-17.3-6.5-160.3,9.8-164.3,21c-4,11.5-90.9,19.8,40.5,20.1l174.2,1.1c5.4-12.6,13.8-27.1,18.8-39.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.7,447.3c-8.9-10.4-42-5.4-48.7-5.4l4.8,10l5.7,9.9l4.6,6.7l4.5,5.7l5.2,5.8l7.9,7.3l11,8h92.1 c0,0.4,71.7-0.6,67.6-12.5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.3,
    y: 493.6,
    className: "st2",
    width: 609.7,
    height: 1.2
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.3,493.6H110.7c-5.5,0-10-4.5-10-10V28.4c0-5.5,4.5-10,10-10h218.6c5.5,0,10,4.5,10,10v455.1 C339.3,489.1,334.8,493.6,329.3,493.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.2,
    y: 95.6,
    className: "st4",
    width: 109.2,
    height: 64.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 222.3,
    y: 95.6,
    className: "st4",
    width: 109.2,
    height: 64.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 162.7,
    className: "st4",
    width: 109.2,
    height: 64.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 221.4,
    y: 162.7,
    className: "st4",
    width: 109.2,
    height: 64.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108.3,
    y: 230.3,
    className: "st4",
    width: 109.2,
    height: 64.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 221.4,
    y: 230.3,
    className: "st5",
    width: 109.2,
    height: 64.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 226.7,
    y: 235.8,
    className: "st6",
    width: 100.5,
    height: 55
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 108.8,
    y: 297.9,
    className: "st4",
    width: 109.2,
    height: 64.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 221.9,
    y: 297.9,
    className: "st4",
    width: 109.2,
    height: 64.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 108.7,
    y: 365.5,
    className: "st4",
    width: 109.2,
    height: 64.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 221.8,
    y: 365.5,
    className: "st4",
    width: 109.2,
    height: 64.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 432.7,
    className: "st4",
    width: 109.2,
    height: 60.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 432.7,
    className: "st4",
    width: 109.2,
    height: 60.9
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M322.5,81.3H116.8c-4.2,0-7.7-1-7.7-2.1V29c0-1.2,3.4-2.1,7.7-2.1h205.7c4.2,0,7.7,1,7.7,2.1v50.2 C330.2,80.4,326.8,81.3,322.5,81.3z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M161.5,61.3h8v4.2h-12.4v-19h4.4V61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M188.6,49.2c1.9,2,2.9,4.2,2.9,6.8s-0.9,4.9-2.8,6.8s-4.1,2.9-6.8,2.9c-2.6,0-4.8-1-6.7-2.9 c-1.9-2-2.9-4.2-2.9-6.9s0.9-5,2.8-6.9c1.9-1.9,4.1-2.9,6.8-2.9C184.5,46.2,186.7,47.2,188.6,49.2z M185.6,52.2 c-1-1.1-2.3-1.6-3.7-1.6s-2.7,0.5-3.7,1.6s-1.5,2.3-1.5,3.8s0.5,2.8,1.5,3.8c1,1.1,2.3,1.6,3.7,1.6s2.7-0.5,3.7-1.6 s1.5-2.4,1.5-3.8C187.1,54.6,186.6,53.3,185.6,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M211.1,63.6c-1.1,0.9-2.2,1.5-3.2,1.8c-1.1,0.3-2.3,0.4-3.7,0.4c-2.7,0-4.9-1-6.8-2.9 c-1.8-1.9-2.7-4.2-2.7-6.8c0-2.7,0.9-5,2.8-6.9c1.9-1.9,4.1-2.9,6.7-2.9c2.8,0,5,0.8,6.7,2.5l-1.6,3.5c-0.2-0.3-0.6-0.6-1.1-1 c-1-0.6-2.3-0.9-4-0.8c-1.4,0.1-2.6,0.7-3.6,1.7s-1.5,2.3-1.5,3.8s0.5,2.8,1.4,3.8c1,1,2.2,1.6,3.6,1.7c1.4,0.1,2.8-0.1,4-0.7 c0.5-0.2,1-0.5,1.3-0.9L211.1,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M231.5,46.5l-7.7,8.8l7.6,10.2H226l-5.1-6.8l-1.3,1.5v5.4h-4.4v-19h4.4v7.3l6.2-7.3L231.5,46.5L231.5,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M239.9,61.4h8.6v4.2h-13.1v-19h12.8v4.2h-8.4v3.5h6.3v4.2h-6.3L239.9,61.4L239.9,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M268.7,65.6h-5.3l-4.1-6.1h-1.5v6.1h-4.4V46.5h7.3c2,0,3.6,0.6,4.9,1.7c1.3,1.1,1.9,2.7,1.9,4.8 c0,2.5-1.2,4.6-3.4,5.7L268.7,65.6z M257.8,50.5v5.1h2.3c2,0,2.9-0.9,2.9-2.5c0-1.7-0.9-2.6-2.6-2.6H257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M283.4,64.1c-1.3,1.1-2.9,1.6-4.7,1.6c-2.5,0-4.8-1-7-3.1l1.8-3.8c1.6,1.8,3.6,2.7,5.3,2.7 c1.5,0,2.3-0.5,2.3-1.5c0-0.9-1.4-1.6-3.1-2.3c-2.5-1-5.8-2.6-5.7-5.9c0-1.6,0.7-3,1.9-4c1.3-1.1,2.8-1.6,4.4-1.6 c2,0,4.1,0.8,6.4,2.5l-1.8,3.8c-1.7-1.4-3.2-2.1-4.6-2.1c-0.9,0-1.8,0.3-1.8,1.3s2.3,1.6,4.5,2.7c2.3,1.1,4.5,2.7,4.3,5.4 C285.5,61.6,284.8,63.1,283.4,64.1z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M192.9,134.2H180c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C197.3,132.2,195.3,134.2,192.9,134.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M309.9,134.2H297c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C314.3,132.2,312.3,134.2,309.9,134.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M192.9,198.2H180c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C197.3,196.2,195.3,198.2,192.9,198.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M309.9,198.2H297c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C314.3,196.2,312.3,198.2,309.9,198.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M192.9,269.2H180c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C197.3,267.2,195.3,269.2,192.9,269.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M192.9,333.2H180c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C197.3,331.2,195.3,333.2,192.9,333.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M309.9,333.2H297c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C314.3,331.2,312.3,333.2,309.9,333.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M192.9,405.2H180c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C197.3,403.2,195.3,405.2,192.9,405.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M309.9,405.2H297c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C314.3,403.2,312.3,405.2,309.9,405.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M192.9,469.2H180c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C197.3,467.2,195.3,469.2,192.9,469.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M309.9,469.2H297c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C314.3,467.2,312.3,469.2,309.9,469.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M487.8,493.5h-16.1c-0.4-0.4-0.4-2.9,0-5.1c-0.4,0-0.4,0-0.8,0c0,0-12-25.4-10.8-30.1 c0.8-1.5-1.7-6.2-4.6-11.3c-0.4,2.5-0.4,4.7-0.8,7.3c-1.2,14.9-2.1,30.9-2.5,34.9c0,0-0.8,0-1.7,0c1.2,0.7,3.7,0.7,5.4,1.1 c1.7,0.4,3.7,2.5,3.7,2.9h-16.1c-0.4-0.4-0.4-2.9,0-4.7c-0.4,0-0.8-0.4-0.8-0.7c0,0-3.7-26.5-1.2-33.4c0.8-2.2,0.8-6.5,0.4-11.3 c0-5.1-0.8-10.9-0.4-15.3c0-0.4,0-1.1,0-1.5c-0.8-0.4-1.2-0.7-1.2-1.1c0-3.3-1.7-26.9,1.2-35.2c0.4-0.7,1.2-2.2,2.5-2.9l0,0 c1.2-1.1,2.5-2.2,3.7-3.3c-0.8-0.7-2.1-1.5-2.1-2.5c0-0.7,0-1.5,0-1.5l0,0c-0.8-1.1-3.3-4-0.4-7.3c2.1-2.5,4.6-2.9,6.6-2.5 c0.8-0.7,1.7-1.5,3.3-1.8c0.8-2.9,1.2-5.1,1.2-5.1s0.4,0,0.8,0c0-1.5-0.4-3.6,0-4.4c0.4-1.1,2.5-3.3,2.9-2.9c0.8,0.4,0,4,0.4,4.4 s0.8-1.5,1.2-1.5c0.4-0.4,0.4,1.8-0.4,2.5c-0.4,0.7-0.8,1.5-0.8,2.2c0.4,0.4,0.8,0.4,0.8,0.7c0,0-1.2,15.6-2.1,17.8l0,0 c0.4,0.7,0,1.5-0.4,2.2h-0.4c-0.4,1.1-1.2,2.2-1.7,3.3c0.8,0,1.7,0,2.5,0l0,0c0.8-0.4,12.4-10.5,13.2-12.4c0.8-1.8,1.7-12,1.7-12 l0,0c0-0.4-0.4-1.5-0.8-1.8c-0.8-0.4-0.8-2.5-0.4-2.5c0.8,0,0.8,1.8,1.2,1.5s0-4,0.4-4.4c0.8,0,2.5,1.8,2.9,2.9s0,3.6,0,4.7 c0.4,0,0.8,0,0.8,0.4c0,0,2.5,10.2,2.1,12.7c-0.8,2.5-11.2,20-12.4,20.7l0,0l0,0c1.7,10.2,3.3,25.4,2.5,27.2l0,0 c-0.4,0.4-1.2,0.7-2.5,1.1l12.4,61.8c0,0-0.4,0.4-1.2,0.4c1.2,2.2,5,2.9,7.4,3.3C488.2,491.3,488.6,492.7,487.8,493.5z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M374.7,177.8c-7.3-3.6-13.4-1.2-13.4-1.2c-21.9-2.4-28.5,23.7-28.5,32.8c0,9.7,1.2,19.4-9.1,31 c-29.7,34,31.6,35.2,31.6,35.2c0.6-27.3,32.8-17.6,31.6-14.6C428.1,270.7,391.1,186.9,374.7,177.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M341.9,244c0,0-10.3,2.4-13.4,6.7c-3,4.2-15.2,40.7-17.6,41.3c-2.4,1.2-24.3-3.6-24.3-3.6s-3.6,4.2-1.2,9.1 c0,0,7.9,11.5,18.8,16.4l0,0c3.6,2.4,8.5,3,12.7,2.4c9.7-1.2,17-7.9,21.2-14c3.6-4.9,6.1-9.1,6.1-9.1L341.9,244z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M286.4,298.3c0,0-6.4,0.2-10.1-2c-3.2-1.8-9.2-10.8-8.5-11.7c1.7-0.2,10.7,3.3,11.1,2.8 c1.3,0.3-4.1-2.6-3.7-3.1s4.6-1.7,7.8,0.1c1.8,0.7,6.5,4.6,6.5,4.6L286.4,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M425.7,531.1l-10.9,3c0,0-0.6,7.9-0.6,14s-2.4,12.1-7.3,13.4c-5.5,1.2-3,4.9-3,4.9s10.9,0,14,0 c3,0,6.7-2.4,7.3-7.9s6.7-8.5,7.9-12.7c1.8-4.9-4.9-10.9-4.9-10.9L425.7,531.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M355.8,547.5c-1.8,8.5-12.7,12.1-18.8,12.7s-6.1,4.9-6.1,4.9h38.8c3-1.2,0.6-27.9,0.6-27.9 S358.3,539,355.8,547.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M334.6,344.2c10.9-36.4-1.2-44.9,0-63.1s7.3-35.8,7.3-35.8s1.2-0.6,3.6-1.2c4.2-1.8,7.3-5.5,7.3-9.7l0,0 c0-5.5-0.6-10.3-0.6-10.3l17-3.6h0.6c0,6.7,1.2,12.7,2.4,16.4c1.2,3,4.2,5.5,7.3,6.1c0.6,0,3,0.6,3.6,0.6c0,0,3,72.2,2.4,76.5 c-1.2,4.9,3.6,10.3,11.5,27.9C402,357.5,322.5,381.8,334.6,344.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M370.4,219.7c-2.4,4.9-7.3,14-17,14c0-5.5-0.6-10.3-0.6-10.3L370.4,219.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M343.1,200.3c1.2-5.5,3.6-10.3,18.2-9.7s11.5,10.3,11.5,24.3c0,14.6-23.1,14-23.1,14 C343.7,228.2,340.7,204.5,343.1,200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M372.2,193c2.4,10.3,10.3,16.4,10.3,16.4s-4.2,2.4-15.2,0c-10.3-2.4-17-18.8-17-18.8 C355.2,182.7,372.8,193.6,372.2,193z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M342.5,191.8c-4.9,6.7-0.6,17.6-0.6,17.6c-0.6-6.1,0.6-10.3,3-13.4c2.4-3.6,6.7-4.9,6.7-4.9 S348,185.1,342.5,191.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M383.8,242.8c-23.7,18.8-41.9,1.2-41.9,1.2s-6.1,10.9-10.3,27.3c-4.2,15.8,6.1,44.3,6.1,44.3l21.9,6.7l7.3-1.2 l20-4.9c0,0,2.4-1.2,4.9-6.1c1.8-1.8,1.8-7.9,2.4-14.6c0.6-9.7,0.6-20.6,0.6-20.6L383.8,242.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M338.8,320.5l30.4-0.6c0,0,0,34,4.9,73.4c6.1,39.5-3,149.9-3,149.9s-1.2,2.4-7.3,3.6 c-4.2,0.6-7.3-0.6-7.3-0.6s-6.7-3-7.3-7.9c-0.6-4.9-22.5-160.3-21.9-171.8C327.9,355.1,338.8,320.5,338.8,320.5L338.8,320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M347.3,323.5c0,0-7.3,29.7-3,37c18.2,31,27.3,83.2,27.9,91.1c1.2,12.1,27.9,65.6,35.8,82.6 c1.2,3,4.9,4.2,7.9,3.6c1.2-0.6,3-0.6,4.2-1.2c3.6-1.2,4.9-4.2,4.9-4.2c0-47.3-11.5-75.9-15.2-90.4c-3.6-14.6-4.9-68.6-6.1-83.8 S385.5,320,385.5,320L347.3,323.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M337.6,324.1c19.4,6.7,51-1.2,51-1.2c0-3.6-1.2-6.7-1.2-6.7s-26.7,3-37,3c-9.1,0-13.4-3.6-13.4-3.6 C335.8,319.9,337.6,324.1,337.6,324.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M348,327.8c-2.4,0-4.9-1.8-4.9-4.9c0-2.4,1.8-4.9,4.9-4.9c2.4,0,4.9,1.8,4.9,4.9 C352.8,325.9,350.4,327.8,348,327.8z M348,319.3c-1.2,0-3,1.2-3,3.6s1.2,3.6,3,3.6s3-1.2,3-3.6S349.8,319.3,348,319.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M425.7,352c0,0,4.2,4.9,4.9,9.1c0.6,3.6-2.4,14-3.6,14c-1.2-1.2-4.2-10.3-4.9-10.3c-0.6-1.2,0.6,4.9,0,4.9 s-4.2-2.4-4.9-6.1c-0.6-1.8-0.6-7.9-0.6-7.9L425.7,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M373.4,276.8c0,0,11.5,12.1,18.2,30.4c5.5,15.2,21.2,43.1,25.5,49.8c0.6,0.6,2.4,1.2,3,0.6l4.2-1.2 c0.6-0.6,1.2-1.8,1.2-3c-3-14.6-7.3-33.4-10.9-43.1s-7.9-41.9-12.7-52.2c-6.1-13.4-18.8-14.6-18.8-14.6L373.4,276.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M278.6,283.5c-2.4,0.8-15.6,1.1-19.1,3.3c-3.5,2.2-14.2,89.9-8.4,96.3c4.4,4.8,24.1,11.3,34.5,12.2 c1.9-19.2-0.5-74.1,0.4-78.8c0.9-4.7-5.8-12.2-7-19.4C278,291.9,277.9,287.6,278.6,283.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M260.8,286.1c0,0-8.4,6.7-12,11.9c-3.6,5.2-10.8,44.2-11,51.8c5.2-1.5,7.8-5,12.6-5.4 C252.9,338.9,271,309.3,260.8,286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M255.6,345c0,0-4.5,29.5-4.9,36.2c-0.3,4.4-12.5,7.2-15.5,1.5c-7.6-14.4-0.4-21.7,3.3-34.9 C238.4,347.8,254.3,338.4,255.6,345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M279.8,283.5l-0.6,1.2c-0.7,5.1,8.5,29,8.7,31.9c0.1,2.9-1,57.1-1.3,61.9s-13.1-50.3-10.6-56.7 c2.5-6.4,7.5-7.6,4.2-9.2c-3.4-1.7-13.4-15.4-13.7-23.3C266,281.3,269,284,279.8,283.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M248.9,375.3c0,0,19.8,10.6,25.7,12c5.9,1.4,7.6,2,10.5,3.4c0,0,0.1,0,0.1,0.1c0.2,0.1,0.5,0.2,0.7,0.4 c1.7,1.1,2.8,3.8,0.9,4.6c-4.5,2-37.3-11.6-36.8-12.7C251.2,380.5,247.9,376.3,248.9,375.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M250.7,380.5c0,0,1.1,5.9,0.1,7.1c-1,1.1-12.8,2.9-13.9,1.5c-1.1-1.5-1.7-6.4-1.7-6.4 S245.1,386.1,250.7,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M251.9,377.3c0,0-4.1-0.8-6.1-7.9s8.9-22.1,10.3-30.9s2.8-25.3,2.8-25.3s-1.8,16.7-4.4,23.1 s-11,23.2-10.4,32.3C244.7,377.6,251.9,377.3,251.9,377.3z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M551.2,340.9c0,0.7,0.8,3.3,1.7,3.3c0.4,0,0.8,0.7,0.8,1.1c-0.4,0-0.4,0-0.4,0c0.8,5.4,4.1,11.6,7.4,16l0,0 l0,0c0,0,0.4,0.7,0.8,2.2c3.7,11.6,12.8,18.9,14.5,20c0.4,0,0.8,0,0.8,0.4l0,0c1.2,1.1,1.2,2.9,1.2,2.9c-0.4,8.7,0,22.9-0.8,28.3 c0,1.5,1.2,2.5,2.5,2.9c-0.4,2.5-0.8,5.8-0.4,9.4c0.4,4.4-1.7,16.3-4.6,20.7c-5,7.6-5.4,38.5-5.4,38.5c0.4,0,0.4,0.4,0.4,0.4 c-0.4,2.2-0.8,6.5,0,7.3h17.4c-0.4-0.7-0.8-1.5-2.9-1.8c-2.9-0.4-8.3-1.5-9.1-4.7l0,0c0-0.4,0.4-0.4,0.4-0.4l12.4-32 c0,2.2,0.4,4.4,0.4,6.2c0,0.4,0,0.4,0,0.7c1.2,13.8,5.4,25.8,5.4,25.8h0.4c-0.4,2.2-0.8,5.4,0,5.8h17.4c-0.4-0.7-0.8-1.5-2.9-1.8 c-2.5-0.7-7.9-1.5-8.7-4.7c0.4-0.4,0.4-0.4,0.4-0.4s3.3-34.9,4.6-49c0.4-3.6,0.4-6.9,0.8-10.2c0.4-5.4,0.8-9.1,0.8-9.1l0,0 c0.4-1.1,0.4-2.2,0.4-2.5c3.3-2.5,1.2-17.1,0.8-22.5c0,0,0-5.8,0-11.3l0,0l0.4-0.4c12.4-9.8,12-25.1,12-25.1 c-1.2-2.9-4.1-14.9-5-14.9l0,0c0-1.5,0.4-3.6,0.4-4.7c0-1.5-1.7-2.2-2.5-2.2c-0.4,0-1.2,4-1.7,4s-1.7-1.1-2.1-0.7 c-0.8,0,0.8,1.5,1.2,2.2c0,0.4,0.8,1.1,1.7,1.5h-0.8l-0.4,15.6l0,0l0,0c-5.4,6.9-6.6,10.9-8.3,10.9s-6.2,1.8-7,2.2 c0-0.4,0-0.7,0-1.1s0-0.4,0-0.7v-0.4c-0.4-1.5-0.4-2.5-0.4-2.9c1.2,0,1.7-0.4,1.7-0.4c2.1-0.7,0.8-6.9-0.4-9.8 c1.7,0,2.9-0.4,4.1-1.1c0,0-3.3-1.5-4.6-3.6c-0.4-1.1-1.2-2.5-2.9-2.9c-1.2-0.4-2.1-0.4-3.7,0c-4.1,1.1-8.7,3.3-9.9,5.4 c-1.2,2.2-0.4,4.4,0.4,5.4c5,6.2,7,5.4,7,5.4c0.4,2.5,0,4.4-0.4,5.8h-0.4c-0.4,0-5.8-1.1-7.4-0.7c-1.7,0.4-4.1-3.3-10.8-9.1 c0,0-9.1-13.4-12.8-17.1l0,0l0,0c0,0,0-2.9-1.2-4c-0.8-1.1-3.3-2.5-3.7-1.8s1.7,2.5,1.7,3.3C552,340.9,550.8,339.4,551.2,340.9z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M521.3,312.2l-0.4,0.4l-2.9-0.4c0,0-0.8-5.4-0.4-6.9c0.4-1.5,2.9-4.4,3.7-4s0,5.4,0.4,5.8 c0.8,0.4,0.8-1.8,1.7-2.2c0.8-0.4,0.4,2.9-0.4,3.6C521.7,309.3,521.3,312.2,521.3,312.2L521.3,312.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M513.9,349.2c0,0,5-9.1,6.2-12c0.8-2.9,2.9-25.1,2.9-25.1c-1.7-2.2-6.6-1.1-6.6-1.1s-5.4,20.3-5.4,21.8 c-0.4,1.1-7,7.6-12,12c-2.1,1.5-0.4,4.4,2.1,4.4L513.9,349.2L513.9,349.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M540.8,312.2l0.4,0.4l2.9-0.4c0,0,0.8-5.4,0.4-6.9c-0.4-1.5-2.9-4.4-3.7-4s0,5.4-0.4,5.8 c-0.8,0.4-0.8-1.8-1.7-2.2c-0.8-0.4-0.4,2.9,0.4,3.6C540.3,309.3,540.8,312.2,540.8,312.2L540.8,312.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M557.3,489.8c-3.7-0.7-9.9-1.5-11.2-5.8c-0.8-4.4-7.4-1.5-7.4-1.5s-2.1,9.4-0.4,10.5H561 C560.6,492.4,559.8,490.2,557.3,489.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M516.3,489.1c-3.3-0.7-8.3,0-9.5-4.4s-7.4-2.2-7.4-2.2s-2.1,9.4-0.4,10.5h22.8 C521.3,492.4,518.8,489.5,516.3,489.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M499,391c-2.1,1.5-3.3,4-3.7,7.6c0,1.1,0,2.2-0.4,3.3c-0.4,6.2,0.4,14.2,0.8,21.4c0.4,6.5,0.8,12.4-0.4,15.6 c-3.3,9.8,1.7,46.5,1.7,46.5c2.1,3.6,13.7,1.8,13.7,1.8c0.8-5.8,1.7-27.6,3.7-49c2.1-21.4,4.1-41,4.1-41S508.9,385.6,499,391z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M499,391c-2.1,1.5-3.3,4-3.7,7.6c0,1.1,0,2.2-0.4,3.3c-0.4,6.2,0.4,14.2,0.8,21.4l18.6,14.9 c2.1-21.4,4.1-41,4.1-41S508.9,385.6,499,391z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M504.8,392.1c-13.7,3.3,19,45.4,17,51.9c-2.1,6.5,14.9,42.1,14.9,42.1c5,0.7,11.6-1.1,11.6-1.1l-18.6-93 C529.6,392.1,518.4,389.2,504.8,392.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M515.9,347.4c0-3.6-1.2-7.6-1.2-7.6c0-0.4-9.1-4.4-8.7-1.5c0.4,3.6-0.4,6.9-0.8,9.1H515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M515.5,325.6c-0.8-0.7-1.7-1.5-3.3-1.8c-2.1-0.4-4.6,0-8.3,1.8c-7,3.6-3.3,7.3,0.4,13.4 c2.1,3.6,6.6,3.3,10.3,2.5c2.5-0.7,4.1-1.5,4.1-1.5C521.7,338.7,516.8,327.4,515.5,325.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M493.6,398.6c0,4.4,38.1,2.5,40.5-1.1l0,0c1.7-2.5-1.2-23.6-3.3-37.8c0-0.4,0-0.4,0-0.4c0.4,0,0.4,0,0.4,0 c1.7-1.1,16.1-25.4,17-29.1c0.8-3.6-2.9-18.2-2.9-18.2c-1.2-1.1-5-0.7-5-0.7s-1.2,14.2-2.5,16.7c-0.8,2.5-17,16.7-18.2,17.1l0,0 c-1.2-0.4-2.5-0.4-3.3-0.4c-4.6,0-7,1.5-10.8,0c-6.6-2.2-9.5,1.8-10.3,4.4C491.1,360.9,493.2,393.9,493.6,398.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M530.8,359.4c-1.7,2.9-11.2,21.4-8.3,27.6c1.7,4,7,8,11.6,10.2C535.8,394.6,532.9,373.6,530.8,359.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M500.2,338.7c0,0,5,1.8,5,3.3c0,0,5.4,0,6.2-1.5c0.8-1.5,2.9-4,2.1-4.7c-0.8-0.7-2.1-2.5-0.8-2.5 c1.3,0,2.1-4.4,1.7-4.7c0,0-0.8-2.2,0.4-3.6c1.2-1.5-1.7-6.5-1.7-6.5s-2.5,2.5-7.9,3.3C499.8,322.4,492.8,331.8,500.2,338.7z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    className: "st11",
    d: "M284,296.2c0,0-0.4-2.4-1.2-3.5s-4.1-4.2-4.1-4.6c0.1-1.1-8.8-4-7-5.5 c1-1.1,11.3,1.3,12.8,3.1c1.5,1.8,1.1,9.3,1.1,9.3L284,296.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockersale);
export default __webpack_public_path__ + "static/media/lockersale.ff8ff731f66cfb0a73661c3042f510d6.svg";
export { ForwardRef as ReactComponent };